import React from 'react';

const PhoneNumbers = ({ phoneNumbers }) => {
  return (
    <div className="margin-top-40">
      <ul className="list simple">
        {phoneNumbers.map(item => (
          <li key={item.name} className="margin-top-10">
            <span>{item.name}:</span>
            {item.number}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PhoneNumbers;



// WEBPACK FOOTER //
// ./src/components/PhoneNumbers.js